var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list_1_",
    "data-name": "list (1)",
    transform: "translate(0.346 -0.231)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 24,
    height: 24,
    transform: "translate(-0.346 0.231)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M.792,13.5a.81.81,0,0,1,0-1.619H9.25a.81.81,0,0,1,0,1.619Zm0-6.479a.81.81,0,0,1,0-1.62H17.707a.81.81,0,0,1,0,1.62Zm0-5.4A.8.8,0,0,1,0,.811.8.8,0,0,1,.792,0H13.479a.8.8,0,0,1,.793.811.8.8,0,0,1-.793.81Z",
    transform: "translate(2.904 5.48)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList1);
export default __webpack_public_path__ + "static/media/list (1).36ab70e0fe035e64a3209fc9b05dccda.svg";
export { ForwardRef as ReactComponent };